import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver';
import { logError } from './logger';


export const exportToExcel = (excelData: any[], label: string, excludedFields: string[], renamedFields: Record<string, string>, fieldOrder: string[], baseUrl?: string) => {
  const Max_CELL_LENGTH = 32767;

  const currentDate = new Date();
  const formattedDate = currentDate
    .toISOString()
    .slice(0, 10)
    .replace(/-/g, '');

  const transformedData = excelData.map((row, rowIndex) => {
    const transformedRow: any = {};
    fieldOrder.forEach((field) => {
      if (excludedFields.includes(field)) return;
      const originalKey = Object.keys(renamedFields).find((key) => renamedFields[key] === field) || field;
      let value = row[originalKey];

      if (value !== undefined) {
        // Handle stringified arrays
        if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
          try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
              value = parsed.join(', ');
            }
          } catch {
            value = value.slice(1, -1);
          }
        }

        // Use base url for the url field
        if (baseUrl && (field.toLowerCase() === 'url') && row['identifier'] && (row['identifier'] !== '["N/A"]')) {

          // Check if reference contains COMPETITIVE_CALLen
          if (row['reference'] && row['reference'].includes('COMPETITIVE_CALLen')) {
            const numberMatch = row['reference'].match(/^(\d+)/);
            if (numberMatch) {
              const number = numberMatch[1];
              value = `https://ec.europa.eu/info/funding-tenders/opportunities/portal/screen/opportunities/competitive-calls-cs/${number}`;
            } else {
              let parseIdentifier = JSON.parse(row['identifier']).join(', ');
              value = `${baseUrl}${parseIdentifier}`;
            }
          } else {
            let parseIdentifier = JSON.parse(row['identifier']).join(', ');
            value = `${baseUrl}${parseIdentifier}`;
          }
        }

        if (field.toLowerCase() === "description") {
          value = typeof value === 'string' ? value.replaceAll(/<[^>]*>/g, '') : value;
        }

        // Handle budget field - convert to number
        if (field.toLowerCase() === 'budget') {
          transformedRow['indicativeNumberOfGrants'] = "N/A";
          transformedRow['expectedContribution'] = "N/A";
          
          if (row["identifier"] !== '["N/A"]') {
            try {
              const identifier = JSON.parse(row['identifier'])[0];
              if (value !== '["N/A"]') {
                const val = JSON.parse(value);
                const budgetMap = val?.budgetTopicActionMap;
                for (const key in budgetMap) {
                  const budgetItems = budgetMap[key];
                  for (const item of budgetItems) {
                    if (item?.action.includes(identifier)) {
                      // Set indicativeNumberOfGrants
                      if (item?.expectedGrants !== undefined) {
                        transformedRow['indicativeNumberOfGrants'] = item?.expectedGrants !== 0 ? item?.expectedGrants : "N/A";
                      }
  
                      // Set expectedContribution
                      if (item?.maxContribution !== undefined && item?.minContribution !== undefined) {
                        if (item?.maxContribution === 0 && item?.minContribution === 0) {
                          transformedRow['expectedContribution'] = "N/A";
                        } else {
                          transformedRow['expectedContribution'] = `${item?.minContribution} - ${item?.maxContribution}`;
                        }
                      }
  
                      if (Object.keys(item?.budgetYearMap).length === 0) {
                        value = 0;
                      } else {
                        const years = Object.keys(item?.budgetYearMap);
                        let budgetStr = "";
                        years.forEach((year, index) => {
                          const budget = item.budgetYearMap[year];
                          budgetStr += `${year}: ${budget}`;
                          if (index < years.length - 1) {
                            budgetStr += ", ";
                          }
                        });
                        value = budgetStr;
                      }
                    }
                  }
                }
              }
            } catch (error) {
              // Log error silently or use proper logger
              logError(error);
              value = 0;
            }
          }
        }

        if (field.toLowerCase() === "deadlinedate" || field.toLowerCase() === "openingdate") {
          if (typeof value === 'string') {
            if (value.includes(',')) {
              value = value.split(',').map(date => date.trim().split('T')[0]).join(', ');
            } else {
              value = value.split('T')[0];
            }
          }
        }

        if (typeof value === 'string' && value.length > Max_CELL_LENGTH) {
          const chunks = [];
          for (let i = 0; i < value.length; i += Max_CELL_LENGTH) {
            chunks.push(value.slice(i, i + Max_CELL_LENGTH));
          }
          chunks.forEach((chunk, index) => {
            transformedRow[`${field}_part${index + 1}`] = chunk;
          });
        } else {
          transformedRow[field] = value;
        }
      }
    });

    return transformedRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(transformedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `${label}-${formattedDate}.xlsx`);
};
